// lineItems/renderers/mnh.renderer.js

export const renderMnhItems = (items = [], showTaxAmount = false) => {
  /* 🔹 Table Header */
  /* 🔹 Service Items Table */
  const servicesHtml = items
    .map((s) => {
      const sl = s.slNo || "";
      const service = s.serviceName || "";
      const gross = s.gross?.toFixed(2) || "";
      const discount = s.discount?.toFixed(2) || "";
      const net = s.netAmount?.toFixed(2) || "";
      const taxRate = s.taxRate ? s.taxRate * 100 : "";

      if (s.isConsolidated) {
        return `
        <tr style="font-size:12px;">
          <td style="text-align:center;">${sl}</td>
          <td colspan="3">${service}</td>
          <td style="text-align:right;">${gross}</td>
          <td style="text-align:right;">${discount}</td>
          <td style="text-align:right;">${net}</td>
        </tr>`;
      }

      return `
      <tr style="font-size:12px;">
        <td style="text-align:center;">${sl}</td>
        <td>${service}</td>
        <td style="text-align:right;">${s.charges?.toFixed(2) || ""}</td>
        <td style="text-align:center;">${s.units || ""}</td>
        ${showTaxAmount ? `<td style="text-align:center;">${taxRate}</td>` : ""}
        <td style="text-align:right;">${gross}</td>
        <td style="text-align:right;">${discount}</td>
        <td style="text-align:right;">${net}</td>
      </tr>`;
    })
    .join("");

  /* 🔹 Table Header */
  const tableHeader = `
  <tr>
    <th>Sl No</th>
    <th>Service Name</th>
    <th>Charges (Rs)</th>
    <th>Units</th>
    ${showTaxAmount ? `<th>Tax (%)</th>` : ""}
    <th>Gross</th>
    <th>Discount</th>
    <th>Net Amount (Rs)</th>
  </tr>
`;

  /* 🔹 Final Table HTML */
  return `<table border="1" cellspacing="0" cellpadding="5"
        style="border-collapse:collapse; font-size:12px; width:100%; table-layout:auto;">
    <thead>${tableHeader}</thead>
    <tbody>${servicesHtml}</tbody>
  </table>
`;
};
